module.exports = __webpack_public_path__ + "static/media/icon-siparislerim.9fe547a2.svg";